export default __webpack_public_path__ + "static/media/pos.bf1698bd.png";